import { Icon, MuiAlert, Typography, strIsNullOrEmpty } from '@fox/atoms';
import { Flex } from '@fox/layout';
import * as moment from 'moment';
import { useState } from 'react';
import styled, { useTheme } from 'styled-components';
import { SwiftFoxEvent } from '../events/contracts';
import { RsvpButton } from '../events/rsvp-button';
import { MobileEventDrawer } from './details-drawer';
import { useEventListContext } from './event-list-context';
import { getEventType } from './util';

const MobileViewWrapper = styled.div`
	padding: 1rem;
	flex-direction: column;
	gap: 1rem;
`;

const MobileItemWrapper = styled.div`
	flex-wrap: wrap;
	flex-direction: column;
	display: flex;
	width: 100%;
	border-radius: 10px;
	border: 1px solid ${props => props.theme.palette.grey[300]};
	padding: 1rem;
	margin-bottom: 1rem;
`;

function MobileItem({ event }: { event: SwiftFoxEvent }) {
	const [mobileDrawerOpen, setMobileDrawerOpen] = useState<boolean>(false);
	const theme = useTheme();
	const type = getEventType(event);
	const startDate = event.eventStart ? moment(event.eventStart).format('h.mm a, DD MMM YYYY') : '';
	const { refetch, rsvpOptions } = useEventListContext();
	return (
		<>
			<MobileItemWrapper>
				<Typography sx={{ marginBottom: '0.5rem', fontSize: '2rem' }} variant="h3">
					{event.name}
				</Typography>
				<span>
					{startDate ? <span>When: {startDate} | </span> : null}
					<span style={{ color: theme.colors.primary, fontWeight: 'bold' }}>{type}</span>
				</span>
				{event.location?.formatted ? <span>Where: {event.location.formatted}</span> : null}
				{!strIsNullOrEmpty(event.rsvpStatus) ? (
					<MuiAlert severity="success" sx={{ backgroundColor: 'transparent', padding: 0 }}>
						{rsvpOptions?.find(option => option.id === event?.rsvpStatus)?.displayName}
					</MuiAlert>
				) : null}
				<Flex style={{ marginTop: '1rem', justifyContent: 'space-between', flexWrap: 'wrap' }}>
					<RsvpButton
						eventStart={event.eventStart}
						isMobile={true}
						eventId={event.id}
						refetch={refetch}
						rsvpFormLink={event.rsvpFormLink}
						availableTickets={event.availableTickets}
					/>
					<Typography
						sx={{ display: 'flex', alignItems: 'center', fontSize: '1.25rem' }}
						variant="h4"
						onClick={() => setMobileDrawerOpen(true)}
					>
						Event Details
						<Icon iconName="ArrowForwardIos" sx={{ fontSize: '1.25rem' }} />
					</Typography>
				</Flex>
			</MobileItemWrapper>
			<MobileEventDrawer drawerOpen={mobileDrawerOpen} setDrawerOpen={setMobileDrawerOpen} eventId={event.id} />
		</>
	);
}

export function MobileView() {
	const { events } = useEventListContext();
	return (
		<MobileViewWrapper>
			{events?.map(event => {
				return <MobileItem key={event.id} event={event} />;
			})}
		</MobileViewWrapper>
	);
}
